import Swiper from 'swiper'
import { A11y } from 'swiper/modules'
import 'swiper/css'
import 'swiper/css/a11y'
const swiper = new Swiper('.feature-slider-container',{
  modules: [A11y],
  a11y: {
    enabled: true
  }
})

const container = document.querySelectorAll('#swiper-nav li')
const slides = document.querySelectorAll('.feature-slider-container .slides')

container.forEach((item,index) => {
  item.addEventListener('click', () => {
    container.forEach( item => item.classList.remove('active') )
    swiper.slideTo(index + 1)
    item.classList.add('active')
  })
});

swiper.on('slideChange', function () {
  container.forEach( item => item.classList.remove('active') )
  slides.forEach( slide => {
    slide.querySelector('.button').tabIndex = -1
  })
  if (swiper.activeIndex > 0 ) {
    const current = swiper.activeIndex - 1
    container[current].classList.add('active')
    const button = slides[current].querySelector('.button')
    if (button) { button.tabIndex = 0 }
  }
});